export default __webpack_public_path__ + "assets/logos/cf4a51c0f96d4ee7a4c3e7661f1dcee4.png";